export default __webpack_public_path__ + "static/media/RingNavInstruction.05961ab3.png";